import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useResourceRuntimeContext } from '~/client/src/shared/hooks/useResourceRuntimeContext'
import { useSensorResourceStore } from '~/client/src/shared/hooks/useSensorResourceStore'

import { createResourceProvider } from '../../components/Resource/createResourceProvider'

export const StruxTagsProvider = createResourceProvider({
  resourceTypeId: ResourceTypeId.SENSORS,
  useSource: useSensorResourceStore,
  columnConfigKey: LocalStorageKey.StruxTagsColumnConfig,
  useRuntimeContext: useResourceRuntimeContext,
})
